import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";

import "./two-col-five-stories.m.css";

export const OtherStory = ({
  story,
  showThumbnail,
  showReadTime,
  showTimestamp,
  showBorder,
  defaultFallback,
  sectionSlug,
}) => {
  const sponsor = get(story, ["metadata", "sponsored-by"], null);
  const isPartneredContent = story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");
  const showImageThumbnail = (showThumbnail || isPartneredContent) && (imageUrl || defaultFallback);
  const headline = getStoryHeadline(story);
  const headlineStyleName = showImageThumbnail ? "show-thumbnail" : "hide-thumbnail"; // Full width if no image
  const isMobile = useDeviceType() === "mobile";
  const label = getStoryLabel(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName={`common-story`} key={story.id} style={{ border: showBorder || "none" }}>
      <Link href={href} target={target}>
        <div styleName="second-card">
          <div styleName={`left-column ${headlineStyleName}`}>
            {label && <Label story={story} />}

            {headline && <Headline styleName="heading" headline={headline} sectionSlug={sectionSlug} />}

            <PublishAndReadTime showReadTime={showReadTime} showTimestamp={showTimestamp} story={story} />
          </div>
          {showImageThumbnail && (
            <div styleName="hero-image">
              <HeroImage
                story={story}
                headline={headline}
                aspectRatio={[[4, 3]]}
                iconSizes={{ height: 24, width: 24 }}
                imageUrl={imageUrl}
              />
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

OtherStory.propTypes = {
  story: object,
  showThumbnail: bool,
  showBorder: bool,
  showReadTime: bool,
  showTimestamp: bool,
  defaultFallback: bool,
  sectionSlug: string,
};
